export default "network.host: 0.0.0.0\nhttp.port: $mainPort\ndiscovery.type: single-node\n";